export const OAUTH_EXCHANGE_SYSTEM_SCHEMA_STATEMENTS = [
  `CREATE TABLE IF NOT EXISTS _gencow_oauth_codes (
    code_hash TEXT PRIMARY KEY,
    session_token_encrypted TEXT NOT NULL,
    token_iv TEXT NOT NULL,
    user_id TEXT NOT NULL,
    user_email TEXT NOT NULL,
    user_name TEXT,
    expires_at TIMESTAMPTZ NOT NULL,
    used_at TIMESTAMPTZ,
    created_at TIMESTAMPTZ DEFAULT NOW() NOT NULL
  )`,
  `CREATE INDEX IF NOT EXISTS idx__gencow_oauth_codes_expires
    ON _gencow_oauth_codes (expires_at)`,
  `CREATE TABLE IF NOT EXISTS _gencow_oauth_invite_reservations (
    token_hash TEXT PRIMARY KEY,
    invite_code TEXT NOT NULL,
    provider_id TEXT NOT NULL,
    status TEXT NOT NULL DEFAULT 'pending',
    user_id TEXT,
    user_email TEXT,
    expires_at TIMESTAMPTZ NOT NULL,
    completed_at TIMESTAMPTZ,
    released_at TIMESTAMPTZ,
    created_at TIMESTAMPTZ DEFAULT NOW() NOT NULL
  )`,
  `CREATE INDEX IF NOT EXISTS idx__gencow_oauth_invite_reservations_expires
    ON _gencow_oauth_invite_reservations (status, expires_at)`,
  `CREATE TABLE IF NOT EXISTS _gencow_oauth_signup_handoffs (
    token_hash TEXT PRIMARY KEY,
    provider_id TEXT NOT NULL,
    status TEXT NOT NULL DEFAULT 'pending',
    user_id TEXT,
    user_email TEXT,
    expires_at TIMESTAMPTZ NOT NULL,
    completed_at TIMESTAMPTZ,
    released_at TIMESTAMPTZ,
    created_at TIMESTAMPTZ DEFAULT NOW() NOT NULL
  )`,
  `CREATE INDEX IF NOT EXISTS idx__gencow_oauth_signup_handoffs_expires
    ON _gencow_oauth_signup_handoffs (status, expires_at)`,
] as const;
